import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseApiService } from './auth/base-api.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VersionService extends BaseApiService {
  constructor(http: HttpClient) {
    super(http);
  }

  public async getCurrentVersion(): Promise<number> {
    const origin = window.location.origin;
    return lastValueFrom(this.http.get<number>(`${origin}/ver/build-num.txt`));
  }
}
